module.exports = __webpack_public_path__ + "img/photo_2023-11-22 14.30.24.c00518bb.jpg";